import type { ButtonHTMLAttributes, DetailedHTMLProps, FC, Ref } from "react";
import type { ReactI18NextChildren } from "react-i18next";

import * as styles from "./NoStyleButton.styles";

interface NoStyleButtonProps
  extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  children?: ReactI18NextChildren;
  innerRef?: Ref<any>;
}

const NoStyleButton: FC<NoStyleButtonProps> = ({ children, innerRef, ...rest }) => {
  return (
    <button css={styles.noStyle} ref={innerRef} {...rest}>
      {children}
    </button>
  );
};

export type { NoStyleButtonProps };
export { NoStyleButton };
